import { useState } from "react";

const FIELDS = [
  ["label", "Name", "text", "Hire 2 engineers"],
  ["expense_change_monthly", "Extra monthly cost ($)", "number", "24000"],
  ["revenue_change_monthly", "Extra monthly revenue ($)", "number", "0"],
  ["one_time_cash", "One-time cash in (+) / out (−) ($)", "number", "0"],
  ["start_month", "Starts in month", "number", "1"],
];

export const ScenarioBuilder = ({ onPreview, onDone }) => {
  const [f, setF] = useState({ label: "", expense_change_monthly: "", revenue_change_monthly: "", one_time_cash: "", start_month: "1" });
  const submit = (e) => {
    e.preventDefault();
    onPreview({
      label: f.label.trim() || "Custom scenario",
      expense_change_monthly: Number(f.expense_change_monthly) || 0,
      revenue_change_monthly: Number(f.revenue_change_monthly) || 0,
      one_time_cash: Number(f.one_time_cash) || 0,
      growth_rate: null,
      start_month: Math.min(24, Math.max(1, parseInt(f.start_month, 10) || 1)),
    });
    onDone();
  };
  return (
    <form data-testid="scenario-builder" onSubmit={submit} className="px-4 pt-4 grid grid-cols-2 gap-3">
      {FIELDS.map(([k, label, type, ph]) => (
        <label key={k} className={`text-[11px] text-[#A3A3A3] ${k === "label" ? "col-span-2" : ""}`}>
          {label}
          <input data-testid={`builder-${k}`} type={type} value={f[k]} placeholder={ph} maxLength={60}
            onChange={(e) => setF({ ...f, [k]: e.target.value })}
            className="mt-1 w-full rounded-lg bg-[#050505] border border-[#2A2A2A] px-3 py-2 text-sm text-white font-mono focus:ring-2 focus:ring-[#9D00FF] focus:outline-none" />
        </label>
      ))}
      <button data-testid="builder-preview-btn" className="col-span-2 rounded-full bg-[#9D00FF] py-2 text-sm text-white hover:shadow-[0_0_16px_rgba(157,0,255,0.6)] transition-shadow">
        Plot on chart
      </button>
    </form>
  );
};
